import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { GalleryCasinoModule } from './gallery-casino/gallery-casino.module';
import { LobbyVerticalsModule } from './keywords-casino/lobby-verticals.module';




@NgModule({
  declarations: [],
  imports: [
    CommonModule,
    GalleryCasinoModule,
    LobbyVerticalsModule,
  ],
  exports:[
    GalleryCasinoModule,
    LobbyVerticalsModule,
  ]
})
export class CasinoLobbyModule { }
